import React from 'react';
import { AttentionIcon,Box, Inscription, RoundCloseIcon } from '@common-fe/common-fe';

import theme from '@/styles/theme';

interface Props {
  serverError?: string | null;
  infoMessage?: string | null;
}

export const DeductibleErrorInfo: React.FC<Props> = ({ serverError, infoMessage }) => {
  if (!serverError && !infoMessage) return null;
  return (
    <Box gap="s" margin={{ top: 's' }}>
      {serverError && (
        <Box gap="xs" direction="row" align="center" round="container2Round" background="dangerContainer" pad="s" border={{ size: '1px', color: 'dangerBorder' }}>
          <RoundCloseIcon size="24px" color={theme.colors.danger} />
          <Inscription color="textBody">{serverError}</Inscription>
        </Box>
      )}
      {infoMessage && (
        <Box gap="xs" direction="row" align="center" round="container2Round" background="infoContainer" pad="s" border={{ size: '1px', color: 'infoBorder' }}>
          <AttentionIcon size="24px" color={theme.colors.info} />
          <Inscription color="textBody">{infoMessage}</Inscription>
        </Box>
      )}
    </Box>
  );
};
